import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserState {
  check_kyc?: boolean;
  client_id?: string;
  client_secret?: string;
  created_at?: string;
  email_verified?: boolean;
  kyb_status?: string;
  status?: string;
  updated_at?: string;
  id: string | null;
  name: string | null;
  email: string | null;
  // Add more fields as needed
  [key: string]: any;
}

const initialState: UserState = {
  id: null,
  name: null,
  email: null,
  check_kyc: false, 
  client_id: undefined,
  client_secret: undefined,
  created_at: undefined,
  email_verified: false,
  kyb_status: undefined,
  status: undefined,
  updated_at: undefined,
  
};


const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<Partial<UserState>>) {
      console.log(state,action.payload);
      return { ...state, ...action.payload };
    },
    clearUser(state) {
      return { ...initialState };
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
export const userReducer = userSlice.reducer;

// Selector
export const selectUser = (state: { user: UserState }) => state.user; 